import produce from 'immer'
import { SET_BOOKABLES } from './actionTypes'

export const initialState = {
  bookables: {
    data: [],
    count: null,
  },
}

/* eslint-disable default-case */
const appReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_BOOKABLES:
        draft.bookables = action.data
        break
    }
  })

export default appReducer
